export default __webpack_public_path__ + "static/front_house_2-6896c55b159c0962aa9506f4512d983e.jpg";